export const SET_STEPS = '[SETUP STEPS] SET STEPS'
export const LOAD_COMPLETE_STEPS = '[SETUP STEPS] LOAD COMPLETED STEPS'
export const COMPLETE_STEPS = '[SETUP STEPS] COMPLETE STEPS'

export const loadCompletedSteps = (completedSteps) => ({
  type: LOAD_COMPLETE_STEPS,
  payload: completedSteps,
})

export const completedStep = (id) => ({
  type: COMPLETE_STEPS,
  id,
})
